<template>
  <div :key="$route.params.form_id">

    <v-container class="pa-0">
      <v-row no-gutters>
        <v-col>
          <v-btn color="primary" depressed class="mb-4" @click="$router.back()">
            <v-icon left dark>mdi-arrow-left</v-icon> Registraties
          </v-btn>
        </v-col>
        <v-col class="d-sm-flex d-md-flex d-lg-flex d-xl-flex justify-sm-end justify-md-end justify-lg-end justify-xl-end">
          <v-btn color="secondary"
                 outlined
                 depressed
                 class="mb-4 mr-4"
                 @click="resendRegistration"
                 :disabled="resendRegistrationLoading"
                 :loading="resendRegistrationLoading"
                 v-if="registration && registration.registration_status === 'completed'"
          >
            <v-icon
                left
                dark
            >
              mdi-sync
            </v-icon>
            Opnieuw versturen
          </v-btn>

          <v-btn color="secondary"
                 outlined
                 depressed
                 class="mb-4 mr-4"
                 @click="openAssignModal"
                 v-if="registration && registration.registration_status === 'draft'"
          >
            <v-icon
                left
                dark
            >
              mdi-account
            </v-icon>
            Gebruiker toewijzen
          </v-btn>

          <v-tooltip bottom v-if="!registrationIsDeleted() && userHasPermission('eform manage form registrations')">
            <template v-slot:activator="{ on }">
              <v-btn
                  color="secondary"
                  outlined
                  depressed
                  class="mr-4"
                  :disabled="downloadEmailsLoading"
                  :loading="downloadEmailsLoading"
                  @click="downloadEmailAttachments"
                  v-on="on"
              >
                <v-icon
                    left
                    dark
                >
                  mdi-download
                </v-icon>
                Download email bijlagen
              </v-btn>
            </template>
            <span>Bijlagen worden gedownload met de nieuwste versie van de email instellingen</span>
          </v-tooltip>

          <v-btn
              v-if="!registrationIsDeleted() && userHasPermission('eform manage form registrations delete')"
              color="error"
              depressed
              class="mb-4"
              @click="trashRegistrationConfirm"
          >Registratie verwijderen</v-btn>

          <v-btn
              v-if="registrationIsDeleted() && userHasPermission('eform manage form registrations delete')"
              color="warning"
              depressed
              class="mb-4"
              @click="untrashRegistrationConfirm"
          >Registratie uit prullenbak halen</v-btn>

        </v-col>
      </v-row>
    </v-container>

    <v-sheet class="pa-4 rounded-lg">
      <template v-if="registration">
        <registration-view :registration="registration" :form="form"></registration-view>
      </template>
      <template v-else>
        <v-skeleton-loader type="sentences, text@3, sentences, text@2" v-if="loading"></v-skeleton-loader>
      </template>
    </v-sheet>

    <v-dialog v-model="showDownloadModal" max-width="500">
      <v-card>
        <v-card-title class="headline">
          Uw download is klaar
        </v-card-title>
        <v-card-text>
          <p>
            Klik op de onderstaande link om de email bijlagen te downloaden:
          </p>
          <v-btn
              :href="downloadEmailLink"
              target="_blank"
              color="primary"
              outlined
          >
            Download email bijlagen
          </v-btn>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" outlined @click="showDownloadModal = false">
            Sluiten
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showAssignModal" max-width="500">
      <registration-assign :form-id="form_id" :registration="registration" @assign-success="closeReassignModal" @cancel="closeReassignModal"></registration-assign>
    </v-dialog>

  </div>
</template>


<script>
import axios from "axios";
import userHelpers from "../../mixins/userHelpers";
import _ from "lodash";
import RegistrationView from "@/components/RegistrationView.vue";
import RegistrationAssign from "@/components/RegistrationAssign.vue";

export default {
  name: "FormRegistrationView",
  components: {
    RegistrationAssign,
    RegistrationView,
  },
  mixins: [
      userHelpers
  ],
  data() {
    return {
      loading: false,
      resendRegistrationLoading: false,
      downloadEmailsLoading: false,
      downloadEmailLink: null,
      showDownloadModal: false,
      registration: null,
      form: null,
      form_id: this.$route.params.form_id,
      registration_id: this.$route.params.registration_id,
      showAssignModal: false,
    }
  },
  mounted () {
    // Get form data. This fetches the form first and then the registration data.
    this.getDataFromApi()
  },
  methods: {
    async getDataFromApi() {
      this.loading = true
      await this.getFormDataFromApi()
      await this.getRegistrationDataFromApi()
      this.loading = false
    },
    getFormDataFromApi () {
      // Fetch results form the API
      return axios
          .get('api/form/'+this.form_id)
          .then(response => {
            this.form = response.data
          })
          .catch(error => {
            console.log(error)
          })
    },
    getRegistrationDataFromApi () {
      // Fetch results form the API
      return axios
          .get('api/form/'+this.form_id+'/registrations/'+this.registration_id)
          .then(response => {
            this.registration = response.data
          })
          .catch(error => {
            console.log(error)
          })
    },
    async trashRegistrationConfirm() {
      if (
          confirm("Weet je zeker dat je deze registratie wilt verwijderen?")
      ) {
        this.trashRegistration();
      }
    },
    async untrashRegistrationConfirm() {
      if (
          confirm("Weet je zeker dat je deze registratie uit de prullenbak wilt halen?")
      ) {
        this.untrashRegistration();
      }
    },
    async trashRegistration() {
      this.loading = true
      // Fetch results form the API
      axios
        .get('api/form/'+this.form_id+'/registrations/'+this.registration_id+'/trash')
        .then(response => {
          this.$toast.success("Registratie is verplaatst naar de prullenbak.");
          this.registration = response.data
          this.$router.push({name: 'form_registrations', 'form_id': this.form_id});
        })
        .catch(error => {
          console.log(error)
          this.$toast.error("Registratie kon niet worden verplaatst naar de prullenbak.");
        })
        .finally(() => this.loading = false)

    },
    async untrashRegistration() {
      this.loading = true
      // Fetch results form the API
      axios
          .get('api/form/'+this.form_id+'/registrations/'+this.registration_id+'/untrash')
          .then(response => {
            this.$toast.success("Registratie is uit de prullenbak gehaald.");
            this.registration = response.data
            this.$router.push({name: 'form_registrations', 'form_id': this.form_id});
          })
          .catch(error => {
            console.log(error)
            this.$toast.error("Registratie kon niet uit de prullenbak gehaald worden.");
          })
          .finally(() => this.loading = false)

    },
    async resendRegistration() {
      this.resendRegistrationLoading = true

      try {
        let response = await axios.get('api/form/'+this.form_id+'/registrations/'+this.registration_id+'/resend')

        if (response && response.status === 201) {
          this.$toast.success("Registratie is opnieuw verstuurd.");
        }

      } catch (error) {
        console.log(error);
        this.$toast.error('Registratie kon niet opnieuw verstuurd worden.');
      }

      this.resendRegistrationLoading = false;
    },
    openAssignModal() {
      this.showAssignModal = true;
    },
    closeReassignModal() {
      this.showAssignModal = false;
    },
    downloadEmailAttachments() {
      this.downloadEmailsLoading = true
      // Fetch results form the API
      axios
          .get('api/form/'+this.form_id+'/registrations/'+this.registration_id+'/download-emails')
          .then(response => {
            if (response && response.data && response.data.status === 'success') {
              this.showDownloadModal = true;
              this.downloadEmailLink = response.data.url;
            }
            else {
              this.$toast.error("Bestand konden niet worden gedownload.");
            }
          })
          .finally(() => this.downloadEmailsLoading = false)
    },
    registrationIsDeleted() {
      return _.has(this.registration, 'deleted_at');
    },
  }
}
</script>

<style lang="scss" scoped>

</style>